// src/components/_global/Footer.js

import ChevronUpIcon from "@mui/icons-material/KeyboardArrowUp";
import {
  Box,
  Container,
  IconButton,
  Link,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

export default function Footer() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const WEBSITE_URL = process.env.REACT_APP_WEBSITE_URL || "https://finatic.co.za";

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // mobile glass effect
  const mobileGlass = {
    backgroundColor: "rgba(255,255,255,0.3)",
    backdropFilter: "blur(10px)",
    borderTop: "1px solid rgba(255,255,255,0.3)",
    color: "#fff",
    textShadow: "0px 1px 2px rgba(0,0,0,0.5)",
  };

  return (
    <Box
      component="footer"
      sx={{
        width: "100%",
        mt: "auto",
        bgcolor: isMobile ? undefined : "grey.50",
        borderTop: isMobile ? undefined : "1px solid",
        borderColor: isMobile ? undefined : "grey.200",
        ...(isMobile ? mobileGlass : {}),
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          boxSizing: "border-box",
          px: 0,
          py: isMobile ? 1 : 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontSize: isMobile ? "0.6rem" : "0.8rem",
              textAlign: "center",
              ...(isMobile
                ? { color: "#fff", textShadow: "0px 1px 2px rgba(0,0,0,0.5)" }
                : { color: "text.secondary" }),
            }}
          >
            Copyright © {new Date().getFullYear()} Finatic.co.za.
          </Typography>

          <Link
            href={WEBSITE_URL + "/privacy"}
            sx={{
              fontSize: isMobile ? "0.6rem" : "0.8rem",
              textDecoration: "underline",
              textAlign: "center",
              ...(isMobile
                ? {
                    color: "#fff",
                    textShadow: "0px 1px 2px rgba(0,0,0,0.5)",
                  }
                : { color: "primary.main", "&:hover": { color: "primary.dark" } }),
            }}
          >
            Privacy Policy
          </Link>

          <Link
            href={WEBSITE_URL + "/terms-conditions"}
            sx={{
              fontSize: isMobile ? "0.6rem" : "0.8rem",
              textDecoration: "underline",
              textAlign: "center",
              ...(isMobile
                ? {
                    color: "#fff",
                    textShadow: "0px 1px 2px rgba(0,0,0,0.5)",
                  }
                : { color: "primary.main", "&:hover": { color: "primary.dark" } }),
            }}
          >
            Terms &amp; Conditions
          </Link>
        </Box>
      </Container>

      {isMobile && (
        <IconButton
          onClick={handleScrollToTop}
          sx={{
            position: "fixed",
            bottom: 16,
            right: 16,
            bgcolor: "primary.main",
            color: "#fff",
            borderRadius: "50%",
            width: 40,
            height: 40,
            "&:hover": { bgcolor: "primary.dark" },
            boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.2)",
          }}
          aria-label="Scroll to top"
        >
          <ChevronUpIcon sx={{ fontSize: "1.5rem" }} />
        </IconButton>
      )}
    </Box>
  );
}
